/**
 * @module リストパネル部共通コンポーネント
 */
import NormalButton from '../button/Normal.vue';
import CONSTANTS from '../../constants';

export default {
  components: {
    NormalButton,
  },
  data: () => ({
    panelExpand: [],
    CONSTANTS: CONSTANTS,
    width: 0,
    whiteSpace: '',
    contentItems: [],
  }),
  created: function () {
    if (this.$mq === 'pc') {
      this.panelExpand.push(0);
    }
  },
  props: {
    panelTitle: {
      type: Object,
      required: false,
    },
    items: {
      type: Array,
      required: false,
    },
    // 削除ボタンを表示させるかどうか
    isDisplayDeleteButton: {
      type: Boolean,
      default: false,
      required: false,
    },

    // Normalで使用
    buttonType: {
      type: Number,
      default: 1,
      required: false,
    },
    btnTitle: {
      type: String,
      required: false,
    },
    btnAction: {
      type: Function,
      required: false,
    },
    displayType: {
      type: String,
      required: false,
      default: '',
    },
    urlName: {
      type: String,
      required: false,
      default: '',
    },
    // ユーザー警備操作で使用
    noneNickname: {
      type: Boolean,
      default: false,
    },
    // アカウント管理フラグ
    accountManagementFlag: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.width =
      this.$mq === 'pc' ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP;

    this.whiteSpace = this.$mq === 'pc' ? 'normal' : 'break-spaces';

    // 画面サイズ変更
    this.$watch('$mq', function () {
      this.changeItemLabelWidth(
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
      );
    });

    // PCの場合はitemsプロパティが更新されたときにリストを更新する
    if (this.$mq === 'pc') {
      const unwatchItems = this.$watch('items', function () {
        if (this.items.length === 0) {
          return;
        }

        this.contentItems = !this.accountManagementFlag
          ? this.items.filter((item) => !item.url || !item.isVuetifyKey)
          : this.items;
        unwatchItems();
      });
    }
  },
  /** @type {Methods} */
  methods: {
    /**
     * ラベルにニックネームを含むか判定
     * @param {String} val
     * @returns boolean 判定結果
     */
    noneNicknameLabel(val) {
      if (this.noneNickname) {
        const nickname = val.indexOf('ニックネーム');
        if (nickname == -1) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    /**
     * ラベルにテキストを含むか判定
     * @param {String} val テキスト
     * @returns boolean 判定結果
     */
    noneText(val) {
      if (val) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 画面遷移時の処理
     * @param {String} url 画面遷移先
     * @param {function} linkClickAction 画面遷移時のアクション
     */
    router: function (url, linkClickAction = null) {
      if (linkClickAction) {
        linkClickAction();
      }
      this.$router.push({
        path: url,
      });
    },
    /**
     * アイテムラベルのwidthを調整
     * @param {object} width 幅
     */
    changeItemLabelWidth(width) {
      this.width = width;
      this.whiteSpace = this.$mq === 'pc' ? 'normal' : 'break-spaces';
    },
  },
  watch: {
    $mq: function (newValue) {
      // 画面を広げた際に、リスト表示を行う
      if (newValue === 'pc' && this.panelExpand.length === 0) {
        this.panelExpand.push(0);
      }
    },
    panelExpand: function () {
      this.contentItems =
        !this.accountManagementFlag || this.$mq === 'sp'
          ? this.items.filter((item) => !item.url || !item.isVuetifyKey)
          : this.items;
    },
  },
};
